"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_logger_1 = require("mobx-logger");
const react_1 = __importDefault(require("react"));
const ReactDOM = __importStar(require("react-dom"));
require("@brandfree-front/lib/public/css/styles.css");
const config_1 = __importDefault(require("./src/config"));
config_1.default.initialize();
const App_1 = __importDefault(require("./src/App"));
const mobx_1 = require("mobx");
(0, mobx_1.configure)({ enforceActions: 'never' });
if (config_1.default.componentTier === 'dev') {
    (0, mobx_logger_1.enableLogging)({
        action: true,
        reaction: true,
        transaction: true,
        compute: true
    });
}
const render = (AppComponent) => {
    ReactDOM.render(react_1.default.createElement(AppComponent, null), document.getElementById('page-container'));
};
render(App_1.default);
if (module.hot) {
    module.hot.accept('./src/App', () => {
        render(App_1.default);
    });
}
